(function() {
    'use strict';
    angular.module('MW.Influencers.DateTimePicker', [
        'ngSanitize',
        'MW.Framework.TranslationService',
        'MW.Framework.CoreUserService',
        'MW.Framework.TimeOptionsService',
        'MW.Framework.SingleSelectDropdownMenu'])
        .directive('dateTimePicker', [
            '$document',
            'translationService',
            'TimeOptionsService',
            function ($document, translationService, TimeOptionsService) {
                return {
                    templateUrl: 'icm-web/views/partials/date_time_picker',
                    restrict   : 'E',
                    scope      : {
                        selectedDate             : '=',
                        dateTimeFormat           : '=',
                        singleDatePickerCallBack : '&',
                        selectedTime             : '=?',
                        showTimePicker           : '=?',
                        disableSelectDateDropdown: '=?',
                        timezone                 : '=?'
                    },
                    link       : function (scope, element) {
                        scope.datepickerVisible = (typeof scope.disableSelectDateDropdown === 'boolean' ? !scope.disableSelectDateDropdown : false);
                        scope.disableSelectDateDropdown = scope.disableSelectDateDropdown || false;
                        scope.datePickerElement = angular.element('.datepickerVisible');
                        scope.placeholderText = translationService.getLocalizedString('Choose Date');

                        if (!scope.disableSelectDateDropdown) {

                            /**
                             * listener to hide/close when clicking outside the datepicker container
                             */
                            $document.on('click.dateTimeInlineContainer', function onClick(event) {
                                if (scope.datepickerVisible) {
                                    var isClickedElementChildOfPopup = element.find(event.target).length > 0,
                                        elementClassName;
                                    elementClassName = event.target.parentElement.classList;
                                    if (isClickedElementChildOfPopup && elementClassName &&
                                        (elementClassName.contains('ui-datepicker-header') ||
                                            elementClassName.contains('datePicker') ||
                                            elementClassName.contains('ui-datepicker') ||
                                            elementClassName.contains('date'))) {
                                        return;
                                        // Checking this condition as the datepicker next/prev icon trigger another event
                                        // which adding new attrs & class in the elements
                                    } else if (!isClickedElementChildOfPopup &&
                                        (event.target.text === 'Next' && event.target.title === 'Next') ||
                                        (event.target.text === 'Prev' && event.target.title === 'Prev')) {
                                        return;
                                    }

                                    scope.datepickerVisible = false;

                                    // Re-initialise the datepicker
                                    if (scope.selectedDate === '') {
                                        scope.datePickerElement.datepicker('destroy');
                                    }
                                }
                            });

                            /**
                             * Responsible to remove the click event.
                             */
                            scope.$on('$destroy', function onDestroy() {
                                $document.off('click.dateTimeInlineContainer');
                            });
                        }

                    },
                    controller : ['$scope', 'moment', '$element', '$timeout', function ($scope, moment, $element, $timeout) {
                        $scope.singleDatePickerCallBack = ($scope.singleDatePickerCallBack !== undefined && typeof ($scope.singleDatePickerCallBack) === 'function') ? $scope.singleDatePickerCallBack : function () {
                        };

                        if ($scope.timezone) {
                            moment.tz.setDefault($scope.timezone);
                        }

                        var dayMinifiedName  = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                            defaultTimeEntry = {
                                'displayName': translationService.getLocalizedString('Choose Time'),
                                val: 'Choose Time'
                            };
                        /**
                         * @description Handles the event on changing of date and time when scheduling
                         * @param {}
                         */
                        $scope.scheduledDateTimeChangeHandler = function scheduledDateTimeChangeHandler() {
                            var currentDate = moment().format($scope.dateTimeFormat.momentDateFormat);
                            if ($scope.selectedDate && moment($scope.selectedDate, $scope.dateTimeFormat.momentDateFormat).isValid()) {
                                //Check if date + time is in past
                                if (moment($scope.selectedDate, $scope.dateTimeFormat.momentDateFormat).isSame(moment(currentDate, $scope.dateTimeFormat.momentDateFormat))) {
                                    if ($scope.showTimePicker) {
                                        if ($scope.selectedTime) {
                                            $scope.sendTime = $scope.selectedTime;
                                        } else {
                                            $scope.selectedTime = $scope.sendTime;
                                        }
                                        if (moment().format('HH:mm') > '23:55') {
                                            // Code to check an edge case, if current time is beyond 11PM. Time Dropdown should display Choose Time
                                            $scope.scheduledTimeOptions = [defaultTimeEntry];
                                            $scope.sendTime = defaultTimeEntry;
                                            $scope.selectedTime = defaultTimeEntry;
                                        } else {
                                            $scope.scheduledTimeOptions.some(function (timeObj) {
                                                if (moment().format($scope.dateTimeFormat.timeFormat) < timeObj.val) {
                                                    $scope.scheduledTimeOptions.splice(0, $scope.scheduledTimeOptions.indexOf(timeObj));
                                                    if ($scope.selectedTime.val < timeObj.val) {
                                                        $scope.selectedTime = $scope.scheduledTimeOptions[0];
                                                        $scope.sendTime = $scope.scheduledTimeOptions[0];
                                                    }
                                                    return true;
                                                }
                                            });
                                        }
                                    }
                                } else {
                                    if ($scope.showTimePicker) {
                                        //Set the time back to default 8 A.M
                                        $scope.scheduledTimeOptions = angular.copy($scope.fullScheduledTimeOptions);
                                        $scope.selectedTime = ($scope.selectedTime && $scope.selectedTime.val !== defaultTimeEntry.val) ? $scope.selectedTime : $scope.scheduledTimeOptions[8];
                                        $scope.sendTime = ($scope.sendTime && $scope.sendTime.val !== defaultTimeEntry.val) ? $scope.sendTime : $scope.scheduledTimeOptions[8];
                                    }
                                }

                                $scope.singleDatePickerCallBack({
                                    'sendDateObj': $scope.selectedDate,
                                    'sendTimeObj': $scope.selectedTime
                                });
                            }
                        };

                        if ($scope.showTimePicker) {
                            /**
                             * Array of scheduled time options
                             * @type {{val: string, displayName: string}[]}
                             */
                            $scope.scheduledTimeOptions = TimeOptionsService.getHourOptions();
                            $scope.fullScheduledTimeOptions = angular.copy($scope.scheduledTimeOptions);
                            /**
                             * Binding that we use for the send time
                             * @type {{val: string, displayName: string}}
                             */
                            $scope.sendTime = ($scope.showTimePicker) ? $scope.scheduledTimeOptions[8] : defaultTimeEntry;
                            if ($scope.selectedTime && $scope.selectedTime.previousFlag) {
                                $scope.sendTime = $scope.selectedTime;
                                $scope.scheduledDateTimeChangeHandler();
                            }
                        }


                        /**
                         * Responsible to toggle the visibility of the datepicker.
                         * @param {Boolean} - show/hide the datepicker by passing in a boolean true/false.
                         */
                        $scope.openDatepicker = function openDatepicker() {
                            var scheduleStartTomorrow = 0;
                            if (moment().format(this.dateTimeFormat.timeFormat) > '23:55') {
                                scheduleStartTomorrow = 1;
                            }
                            $scope.datePickerElement = $element.find('.datepickerVisible');
                            $scope.datepickerVisible = !$scope.datepickerVisible;

                            //Setup the datepicker
                            $scope.datePickerElement.datepicker({
                                altField   : $scope.datePickerElement,
                                altFormat  : $scope.dateTimeFormat.dateFormat || 'M d, yy',
                                dateFormat : $scope.dateTimeFormat.dateFormat || 'M d, yy',
                                dayNamesMin: dayMinifiedName,
                                firstDay   : 1,
                                minDate    : scheduleStartTomorrow,
                                onSelect   : function startDateCalendarOnSelect(date) {
                                    $scope.$apply(function dateCalendarOnSelectApply() {
                                        $scope.selectedDate = date;
                                        $scope.scheduledDateTimeChangeHandler();
                                        $scope.singleDatePickerCallBack({
                                            'sendDateObj': $scope.selectedDate,
                                            'sendTimeObj': $scope.selectedTime
                                        });
                                    });
                                }
                            });

                            if ($scope.selectedDate === '' || $scope.selectedDate === null) {
                                $scope.selectedDate = $scope.datePickerElement.val();
                                $scope.scheduledDateTimeChangeHandler();
                            }
                            $scope.datePickerElement.datepicker('setDate', $scope.selectedDate);
                            $scope.scheduledDateTimeChangeHandler();
                            $scope.singleDatePickerCallBack({
                                'sendDateObj': $scope.selectedDate,
                                'sendTimeObj': $scope.selectedTime
                            });
                        };

                        if ($scope.disableSelectDateDropdown) {
                            $timeout(function () {
                                $scope.openDatepicker();
                            }, 0, false);
                        }
                    }]
                };
            }]);
})();
